module.exports = __webpack_public_path__ + "static/media/12625852_1056908054330616_1834519825_n.6fa28296.jpg";